// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const ZapIcon = /* @__PURE__ */ createIcon(
  'zap',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M12.231 1.36a1 1 0 0 1 1.761.764L13.132 9h6.16c.252 0 .51-.001.72.017.188.018.55.063.863.316.358.29.564.728.558 1.19-.006.402-.203.709-.31.865-.12.172-.287.37-.448.564l-8.907 10.689a1 1 0 0 1-1.76-.765l.86-6.876h-6.16c-.253 0-.511.001-.72-.018-.19-.017-.55-.062-.863-.315a1.5 1.5 0 0 1-.558-1.19l.011-.146c.043-.33.206-.582.3-.719.12-.173.286-.37.447-.564zM5.135 13H12a1 1 0 0 1 .992 1.124l-.577 4.614L18.865 11H12a1 1 0 0 1-.992-1.124l.576-4.615z',
      },
    ],
  ]
);
